module.exports = __webpack_public_path__ + "img/application_bg3.5e48e6a6.jpg";